import axios from '@axios'

export default {
  findAll(pageConfig) {
    const page = pageConfig.page - 1
    const { size, sort, order } = pageConfig
    const queryUrl = `?page=${page}&size=${size}&sort=${sort},${order}`
    return axios.get(`/financeiro/contas${queryUrl}`)
  },
  find(nome, pageConfig) {
    const page = pageConfig.page - 1
    const { size, sort, order } = pageConfig
    const queryUrl = `?nome=${nome}&page=${page}&size=${size}&sort=${sort},${order}`
    return axios.get(`/financeiro/contas/pesquisa${queryUrl}`)
  },
  findByAtivo() {
    return axios.get('/financeiro/contas/lista')
  },
  findById(id) {
    return axios.get(`/financeiro/contas/${id}`)
  },
  insert(data) {
    return axios.post('/financeiro/contas', data)
  },
  update(data) {
    return axios.put(`/financeiro/contas/${data.id}`, data)
  },
  delete(id) {
    return axios.delete(`/financeiro/contas/${id}`)
  }
}
